/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMessageRequest
 */
export interface CreateMessageRequest {
    /**
     * Sender facility for JWT callers. Must be provided together with
     * participant_id.
     * 
     * This is the direction of the message, not just an identity: it is
     * the referral's sender facility when the sender is writing, and the
     * recipient's own facility when a recipient replies. Those can belong
     * to the same organization, so participant_id alone cannot say which
     * way the message goes.
     * 
     */
    sender_facility_id?: string;
    /**
     * Deprecated — use `participant_id`. Ignored when `participant_id` is
     * present.
     * 
     * An external recipient has no facility, so this field cannot name
     * one. It carried a synthetic value for them, which `Recipient`
     * no longer emits.
     * 
     * @deprecated
     */
    receiver_facility_id?: string;
    /**
     * The thread this message belongs to — the recipient's
     * `Recipient.participant_id`. Must be provided together with
     * sender_facility_id.
     * 
     */
    participant_id?: string;
    /**
     * Display name of the sending user, captured from the frontend at send time.
     */
    sender_user_name?: string;
    /**
     * Job title/role of the sending user, captured from the frontend at send time.
     */
    sender_user_title?: string;
    /**
     * 
     */
    content: string;
}

/**
 * Check if a given object implements the CreateMessageRequest interface.
 */
export function instanceOfCreateMessageRequest(value: object): value is CreateMessageRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CreateMessageRequestFromJSON(json: any): CreateMessageRequest {
    return CreateMessageRequestFromJSONTyped(json, false);
}

export function CreateMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sender_facility_id': json['sender_facility_id'] == null ? undefined : json['sender_facility_id'],
        'receiver_facility_id': json['receiver_facility_id'] == null ? undefined : json['receiver_facility_id'],
        'participant_id': json['participant_id'] == null ? undefined : json['participant_id'],
        'sender_user_name': json['sender_user_name'] == null ? undefined : json['sender_user_name'],
        'sender_user_title': json['sender_user_title'] == null ? undefined : json['sender_user_title'],
        'content': json['content'],
    };
}

export function CreateMessageRequestToJSON(json: any): CreateMessageRequest {
    return CreateMessageRequestToJSONTyped(json, false);
}

export function CreateMessageRequestToJSONTyped(value?: CreateMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sender_facility_id': value['sender_facility_id'],
        'receiver_facility_id': value['receiver_facility_id'],
        'participant_id': value['participant_id'],
        'sender_user_name': value['sender_user_name'],
        'sender_user_title': value['sender_user_title'],
        'content': value['content'],
    };
}

